import React from 'react';
import { IAuditoriaEstoqueSemMovimentoResultado } from '../interfaces/IAuditoriaEstoqueSemMovimento';

interface Props {
  resultado: IAuditoriaEstoqueSemMovimentoResultado;
  onVerDetalhe: () => void;
}

const formatCurrency = (value?: number) =>
  (value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const formatDate = (dateStr?: string) => {
  if (!dateStr) return '—';
  const [y, m, d] = dateStr.split('-');
  return `${d}/${m}/${y}`;
};

const AuditoriaResumoEstoqueSemMovimento: React.FC<Props> = ({ resultado, onVerDetalhe }) => {
  const bordaCor =
    resultado.status === 'ERRO'          ? '#f64e60' :
    resultado.status === 'ALERTA'        ? '#ffa800' :
    resultado.status === 'AVISO'         ? '#ffa800' :
    resultado.status === 'NAO_ANALISADO' ? '#a1a5b7' :
                                           '#1bc5bd';

  const badgeCor =
    resultado.status === 'ERRO'          ? 'danger' :
    resultado.status === 'ALERTA'        ? 'warning' :
    resultado.status === 'AVISO'         ? 'warning' :
    resultado.status === 'NAO_ANALISADO' ? 'secondary' :
                                           'success';

  return (
    <div
      className='card card-custom card-stretch mb-5'
      style={{ borderLeft: `4px solid ${bordaCor}` }}
    >
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-3 mb-1'>
            "Custo de Oportunidade" — Estoques Sem Movimentação (1.01.04.*)
          </span>
          <span className='text-muted mt-1 fw-bold fs-7'>
            Contas de estoque com saldo positivo e sem saída ≥ 180 dias · NBC TG 16 (CPC 16)
          </span>
        </h3>
        <div className='card-toolbar'>
          <span className={`badge badge-light-${badgeCor} fs-7 fw-bold`}>
            {resultado.status === 'NAO_ANALISADO' ? 'NÃO ANALISADO' : resultado.status}
          </span>
        </div>
      </div>

      <div className='card-body pt-3'>
        <div className='row mb-4'>
          <div className='col-3 text-center'>
            <div className='fs-2 fw-bolder text-danger'>{resultado.totalErros}</div>
            <div className='text-muted fs-7'>Erros (≥ 365 dias)</div>
          </div>
          <div className='col-3 text-center'>
            <div className='fs-2 fw-bolder text-warning'>{resultado.totalAlertas}</div>
            <div className='text-muted fs-7'>Alertas (270–364 dias)</div>
          </div>
          <div className='col-3 text-center'>
            <div className='fs-2 fw-bolder text-warning'>{resultado.totalAvisos}</div>
            <div className='text-muted fs-7'>Avisos (180–269 dias)</div>
          </div>
          <div className='col-3 text-center'>
            <div className='fs-2 fw-bolder text-danger'>{formatCurrency(resultado.passivoTributarioTotal)}</div>
            <div className='text-muted fs-7'>Passivo Tributário</div>
          </div>
        </div>

        {resultado.status !== 'CONCILIADO' && resultado.itens.length > 0 && (
          <div className='table-responsive mb-4'>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead>
                <tr className='fw-bolder text-muted'>
                  <th>Empresa</th>
                  <th>Conta</th>
                  <th>Saldo Estoque</th>
                  <th>Última Saída</th>
                  <th>Dias Parados</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {resultado.itens.slice(0, 5).map((item, i) => (
                  <tr key={i}>
                    <td>
                      <span className='fw-bold'>{item.empresaNome}</span>
                      <br />
                      <span className='text-muted fs-8'>{item.cnpj}</span>
                    </td>
                    <td>
                      <span className='fw-bold'>{item.contaReferencial}</span>
                      <br />
                      <span className='text-muted fs-8'>{item.descricaoConta}</span>
                    </td>
                    <td className='fw-bold'>{formatCurrency(item.saldoEstoque)}</td>
                    <td className='text-muted'>
                      {item.houveSaida ? formatDate(item.ultimaMovimentacaoData) : '— nunca houve saída'}
                    </td>
                    <td className='fw-bold'>{item.diasParados}d</td>
                    <td>
                      <span className={`badge badge-light-${item.status === 'ERRO' ? 'danger' : 'warning'}`}>
                        {item.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {resultado.status === 'NAO_ANALISADO' && (
          <div className='alert alert-secondary py-3 fs-8 mb-3'>
            <strong>NÃO ANALISADO:</strong> {resultado.mensagemDirecionamento}
          </div>
        )}

        {resultado.status === 'CONCILIADO' && (
          <div className='text-success fw-bold fs-6'>
            ✓ Nenhuma conta de estoque com saída ausente há {'≥'} 180 dias — de {resultado.quantidadeContasLocalizadas} conta(s) analisada(s).
          </div>
        )}

        <button className='btn btn-sm btn-light-primary mt-2' onClick={onVerDetalhe}>
          Ver detalhes
        </button>
      </div>
    </div>
  );
};

export default AuditoriaResumoEstoqueSemMovimento;
